import { render } from "./contact-form.vue?vue&type=template&id=05c1cad4&scoped=true"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"

import "./contact-form.vue?vue&type=style&index=0&id=05c1cad4&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c1cad4"]])

export default __exports__